import { ACTIONS } from "../../enums/actions";
import { genericAction } from "./genericAction";

export const getBatchHistory = genericAction(ACTIONS.GET_BATCH_HISTORY);
export const setBatchHistoryRequestTypeNum = (payload: any, onSuccess: Function | null = null, onFail: Function | null = null) => ({
    type: ACTIONS.SET_BATCH_HISTORY_REQUEST_TYPE_NUM,
    payload,
    onSuccess: onSuccess || null,
    onFail: onFail || null
});